module.exports = "pegasus/assets/blocks/image-4-theme6.png";